export let nationalitiesByAlpha3: {
  [key: string]: { name: string; aliasTo: string };
} = require("./nationalities-by-alpha3.json");

const nationalitiesValues = Object.keys(nationalitiesByAlpha3).map((key) => ({
  key: key,
  name: nationalitiesByAlpha3[key].name,
  aliasTo: nationalitiesByAlpha3[key].aliasTo,
}));

nationalitiesByAlpha3 = nationalitiesValues
  .sort((a, b) => a.name.localeCompare(b.name))
  .reduce(
    (acc, cur) => ({
      ...acc,
      [cur.key]: { name: cur.name, aliasTo: cur.aliasTo },
    }),
    {}
  );
